const BLOCK_ID = 'shopify-block-ATGhHcmhFZjU4KzlBR__forms_inline_YkndGf';

function updateForm(resource) {
  const block = document.getElementById(BLOCK_ID);
  if (!block || !resource) return;

  block.style.display = resource.available ? 'none' : 'block';

  console.log(
    '[EAFTIMOS]',
    resource.title,
    'available:',
    resource.available,
    'display:',
    block.style.display
  );
}

document.addEventListener('variant:update', (event) => {
  updateForm(event.detail.resource);
});

// Oculta el formulario al cargar la página.
// El primer variant:update volverá a ponerlo visible si la variante inicial no tiene stock.
window.addEventListener('load', () => {
  const block = document.getElementById(BLOCK_ID);
  if (block) {
    block.style.display = 'none';
  }
});